<template>
  <GridAuto
    class="grid"
    hasGap
  >
    <CardStatusButton
      v-for="cardItem in cardItems"
      :key="cardItem.key"
      :data-test-id="$testId(cardItem.key)"
      :icon="cardItem.icon"
      iconPosition="right"
      :label="cardItem.label"
      :title="cardItem.content"
      :type="cardItem.type"
      @click="handleClick(cardItem)"
    />
  </GridAuto>
</template>

<script>
import {
  CardStatusButton,
  GridAuto,
} from '@jumpcloud/ui-components';
import { passwordHealthTypes } from 'client/PasswordManager/PasswordManagerConstants';

const CardItem = ({
  count, totalCount, key, label, errorType,
}) => {
  if (!Number.isInteger(count)) { return null; }

  let cardType = 'default';
  let countDisplay = '0';
  let cardIcon = 'info';

  if (totalCount) {
    cardType = count ? errorType : 'success';
    cardIcon = count ? 'error' : 'checkmarkCircle';
    countDisplay = count.toString();
  }

  return {
    key,
    label,
    content: countDisplay,
    type: cardType,
    icon: cardIcon,
  };
};

export default {
  name: 'PasswordManagerPasswordHealth',

  components: {
    CardStatusButton,
    GridAuto,
  },

  props: {
    compromisedPasswords: {
      type: Number,
      default: undefined,
    },
    oldPasswords: {
      type: Number,
      default: undefined,
    },
    reusedPasswords: {
      type: Number,
      default: undefined,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    weakPasswords: {
      type: Number,
      default: undefined,
    },
  },

  computed: {
    cardItems() {
      return [
        CardItem({
          count: this.reusedPasswords,
          totalCount: this.totalCount,
          key: passwordHealthTypes.reusedPasswords,
          label: 'Reused Passwords',
          errorType: 'warning',
        }),
        CardItem({
          count: this.oldPasswords,
          totalCount: this.totalCount,
          key: passwordHealthTypes.oldPasswords,
          label: 'Old Passwords',
          errorType: 'warning',
        }),
        CardItem({
          count: this.weakPasswords,
          totalCount: this.totalCount,
          key: passwordHealthTypes.weakPasswords,
          label: 'Weak Passwords',
          errorType: 'error',
        }),
        CardItem({
          count: this.compromisedPasswords,
          totalCount: this.totalCount,
          key: passwordHealthTypes.compromisedPasswords,
          label: 'Compromised Passwords',
          errorType: 'error',
        }),
      ].filter(item => item);
    },
  },

  methods: {
    handleClick(cardItem) {
      this.$emit('cardClick', cardItem.key);
    },
  },
};
</script>

<style scoped>
.grid.grid {
  --grid-min-width: 15rem;

  grid-template-columns:
    repeat(
      auto-fit,
      minmax(
        var(--grid-min-width, var(--jc-sidebar-width)),
        1fr
      )
    );
}
</style>
